<template>
    <div class="ml-3">
        <v-btn-toggle dense>
            <v-btn v-for="item in navItems" :key="item.title" :to="{ name: item.to }" exact>
                <span class="hidden-sm-and-down">{{ item.title }}</span>

                <v-icon class="ml-md-2">
                    {{ item.icon }}
                </v-icon>
            </v-btn>
        </v-btn-toggle>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        navItems: {
            type: Array,
            required: true,
        },
        useEvents: {
            type: Boolean,
            required: true,
        },
        filterLabel: {
            type: String,
            required: false,
            default: 'Events',
        },
        filterValues: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            selectedEvent: null,
        }
    },
    mounted() {
        if (this.useEvents) {
            this.selectedEvent = this.currentEvent
        }
    },
    computed: {
        ...mapGetters(['events', 'nextEvent', 'currentEvent']),
        filterSelect() {
            let selectValues = []
            if (this.filterAll) {
                selectValues.push({
                    name: 'All',
                    id: 'ALL',
                })
            }
            return selectValues.concat(
                this.filterValues && this.filterValues.length > 0 ? this.filterValues : this.events,
            )
        },
    },
    methods: {
        eventSelected(val) {
            this.$store.commit('setCurrentEvent', val)
        },
    },
}
</script>
